class GenericDatatable {
  constructor(type, columns, numColumns, hasDetails, allowEdit, allowDelete, allowSupport, defaultSortOrder,
              preventiveSearch) {
    this.table = this.createDataTable(type, columns, numColumns, hasDetails, allowEdit, allowDelete, allowSupport,
        defaultSortOrder, preventiveSearch);
  }

  createDataTable = (type, columns, numColumns, hasDetails, allowEdit, allowDelete, allowSupport, defaultSortOrder,
                     preventiveSearch) => {
    const tableId = `${type}_list`;
    const isReseller = type === 'reseller';
    const actionColIndex = isReseller ? numColumns - 2 : numColumns - 1;
    const requestUrl = `/${type}/data`;
    const entityType = type;
    const columnRenderHandler = (val, type, row) => {
      let actions = '';
      const checkEditByType = () => {
        if (isReseller) {
          return row[actionColIndex + 2];
        } else {
          return true;
        }
      };
      const checkDeleteByType = () => {
        if (isReseller) {
          return row[actionColIndex + 3];
        } else {
          return true;
        }
      };
      if (allowEdit || allowDelete || hasDetails || allowSupport) {
        actions = '<div class="col-action-container"><div class="col-actions">&nbsp;</div><div class="popout" style="display: none;"><ul>';
        if (allowEdit && checkEditByType()) {
          actions += '<li class="popoutitem"><div class="' + entityType + '_edit action" data-list-id="' + tableId + '" _id="' + row[actionColIndex] + '">' + window._edit_label + '</div></li>';
        }
        if (hasDetails) {
          actions += '<li class="popoutitem"><div class="' + entityType + '_details action" _id="' + row[actionColIndex] + '">' + window._details_label + '</div></li>';
        }
        if (allowSupport) {
          actions += '<li class="popoutitem"><div class="' + entityType + '_support action" _id="' + row[actionColIndex] + '">' + window._support_label + '</div></li>';
        }
        if (allowDelete && checkDeleteByType()) {
          actions += '<li class="popoutitem"><div class="' + entityType + '_delete action" data-list-id="' + tableId + '" _id="' + row[actionColIndex] + '">' + window._delete_label + '</div></li>';
        }
        actions += "</ul></div></div>";
      }
      return actions;
    };
    const preventiveSearchHandler = (searchCols, preventiveSearchArray) => {
      let preventiveSearchCols = [];
      if (preventiveSearchArray) {
        for (let column of searchCols) {
          if (column.name in preventiveSearchArray) {
            preventiveSearchCols.push({'search': preventiveSearchArray[column.name]})
          } else {
            preventiveSearchCols.push(null);
          }
        }
      }
      return preventiveSearchCols
    };

    let tableOptions = {
      bFilter: true,
      sPaginationType: "full_numbers",
      serverSide: true,
      autoWidth: false,
      columnDefs: [
        {
          render: columnRenderHandler,
          sortable: false,
          width: '80px',
          class: 'actions',
          targets: [actionColIndex]
        },
        {
          width : 'auto',
          targets: '_all'
        }
      ],
      columns: columns,
      processing: true,
      ajax: {
        url: requestUrl,
        type: "POST"
      },
      fnInitComplete: function (oSettings, json) {
        document.querySelector('.dataTables_filter input').setAttribute('maxlength', 128);
      },
      fnDrawCallback: function (oSettings) {
        const $this = $(this);
        $this.find('tr').click(window.legacytrpopout);

        if (allowEdit) {
          $this.find('.' + type + '_edit').on('click', {entityType: type}, window._menu_edit_click);
        }
        if (allowDelete) {
          $this.find('.' + type + '_delete').on('click', {entityType: type}, window._menu_delete_click);
        }
        if (hasDetails) {
          $this.find('.' + type + '_details').on('click', {fnDetails: window['_view_' + type + '_details']}, window._menu_detail_click);
        }
      },
      createdRow: function (row, data, dataIndex, cells) {
        row.classList.add('trow');
        for (let i = 0; i < cells.length; i++) {
          if (i !== actionColIndex) {
            cells[i].classList.add('multiline');
          }
        }
      }
    }

    if (defaultSortOrder) {
      tableOptions.order = defaultSortOrder;
    }
    const preventiveSearchCols = preventiveSearchHandler(columns, preventiveSearch);
    if (preventiveSearchCols.length > 0) {
      tableOptions.searchCols = preventiveSearchCols;
    }

    return $(`#${tableId}`).DataTable(tableOptions);
  };

  initGtag = () => {
    gtag('event', 'Page', {
      'event_category': 'View',
      'event_label': ` ${this.type} List`
    });
  };
}

export {GenericDatatable};
